module.exports = __webpack_public_path__ + "static/media/systam-success-story-banner.9c432836.webp";